import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: string) =>
  store.dispatch(appActions.setCurrentPage(pageIndex));

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "modularArchitecture",
    iconColor: "white",
    text: "Modular architecture \nleveraging leading \nindustry initiatives",
    listItemCustomStyle: { width: "auto" },
  },
  {
    icon: "autonomousManagement",
    iconColor: "white",
    text: "Platform for all network\n automation needs",
    listItemCustomStyle: { width: "auto" },
  },
  {
    icon: "signal5G",
    iconColor: "white",
    text: "Optimized for cloud-\nnative network function \n& Edge deployments \nand 5G use cases",
    listItemCustomStyle: { width: "auto" },
  },
];

const data = {
  styleLeftPanel: { paddingRight: 0 },
  title: "Infosys Telco Cloud\n Automation",
  text: "Elevate your network with AI powered Infosys Telco Cloud Automation (TCA), \nstreamlining the modeling, onboarding, and deployment of network \nfunctions, Seamlessly integrating IT and network infrastructure automation.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage("ILO_302"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_1"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Intro_01.png",
};

export default data;
